import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import container from '../../helpers/container'
import config from '../../config'
import { includes } from 'lodash'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  GetStartedInput,
  ScreenedCompanies,
} from '../../components'
import Styles from './Companies.css'


@CSSModules(Styles, {allowMultiple: true})
export default class Companies extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const title = 'Companies'
    const url = config.domain + config.routes.companies

    return (
      <div>
        {container.helmet(title, '', url)}
        <div styleName='page'>
          <ContainerDivs>
            <div styleName='title'>
              Civilian firearm manufacturers and retailers
            </div>
            <ScreenedCompanies/>
          </ContainerDivs>
          <GetStartedInput />
        </div>
      </div>
    )
  }
}
